(function () {

    'use strict';

    if (typeof (AMODE) === 'undefined' || AMODE !== 'BACKEND') {
        return;
    }

    angular.module('FotocBackend', ['FotocApp'])
        .constant('CONSTANTS',
            {
                "CANVAS_WIDTH": 1000,
                "CANVAS_HEIGHT": 1000,
            });
})();
